import { HttpClient } from '@angular/common/http';
import * as moment from 'moment';
import { Observable } from 'rxjs';
import { isNullOrUndefined } from 'util';
import { Colaborador } from './recursos-humanos.service';
import { ServicosService } from './servicos.service';

const CLIENT_ID = 'U0lESWNsaWVudF9jcmVkZW50aWFscw==';
const CLIENT_SECRET = 'Y2xpZW50X2NyZWRlbnRpYWxzU0lESQ==';

export class BaseService {

  private token: {
    access_token: string,
    expires_in: number,
    expires_at: moment.Moment,
    token_type: string,

  };

  constructor(protected http: HttpClient) {
  }

  private requestToken(servicos: ServicosService): Observable<void> {
    return new Observable(observer => {
      const url = `${servicos.urls.urlBaseApiAutenticacao}/oauth2/token`;
      const headers = {
        'Accept': 'application/json',
        'Content-Type': 'application/x-www-form-urlencoded'
      };
      const params = {
        'grant_type': 'client_credentials',
        'client_id': CLIENT_ID,
        'client_secret': CLIENT_SECRET
      };
      const options = {
        headers: headers,
        params: params,
        withCredentials: false
      }
      this.http.post(url, null, options).subscribe(value => {
        this.token = {
          access_token: value['access_token'],
          expires_in: value['expires_in'],
          expires_at: moment().add(value['expires_in'] - 60, 'seconds'),
          token_type: value['token_type'],
        };
        observer.next();
        observer.complete();
      });
    });
  }

  private isValidClientToken(): boolean {
    if (isNullOrUndefined(this.token)) {
      return false;
    } else {
      const now = moment();
      return this.token.expires_at.isAfter(now);
    }
  }

  private getColaborador(filtro: string, servicos?: ServicosService): Observable<Colaborador[]> {
    if (isNullOrUndefined(servicos)) {
      return new Observable(observer => {
        observer.next(null);
        observer.complete()
      });
    } else {
      const url = `${servicos.urls.urlBaseApiBasi}/v1/rh/colaboradores/${filtro}/`;
      const options = {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          'Accept': 'application/json',
          'Authorization': `${this.token.token_type} ${this.token.access_token}`
        }
      };
      return this.http.get<Colaborador[]>(url, options);
    }
  }

  private handleColaboradores(login: string, usuario: any, colaboradores: Colaborador[]): Colaborador {
    colaboradores = colaboradores.filter(value => (value.login === login));
    let colaborador: Colaborador;
    if (colaboradores.length === 0) {
      console.warn(`Não há colaborador na API de Recursos Humanos para o usuário "${login}".`)
      if (usuario) {
        return {
          cpf: usuario.cpf,
          cargo: usuario.cargo,
          funcionario: usuario.nome,
          login: usuario.login,
          email: usuario.email
        };
      } else {
        console.warn('Não há dados de usuário.');
        return null;
      }
    } else {
      return colaboradores[0];
    }
  }

  protected getColaboradorByLogin(login: string, usuario?: any, servicos?: ServicosService): Observable<Colaborador> {
    return new Observable<Colaborador>(observer => {
      if (isNullOrUndefined(servicos.urls)) {
        console.warn('As URLs de serviço ainda não foram definidas.');
        observer.next();
        observer.complete();
      } else {
        if (this.isValidClientToken()) {
          this.getColaborador(login, servicos).subscribe(colaboradores => {
            observer.next(this.handleColaboradores(login, usuario, colaboradores));
          });
        } else {
          this.requestToken(servicos).subscribe(
            () => {
              this.getColaborador(login, servicos).subscribe(
                colaboradores => {
                  observer.next(this.handleColaboradores(login, usuario, colaboradores));
                }
              );
            }
          );
        }
      }
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/service/core/base.service.ts